import { createContext } from 'react';
import { Locale } from 'date-fns';

export type Direction = 'ltr' | 'rtl';

export type CultureContextValues = {
    locale: string; // locale code, e.g., "ar-SA"
    dir: Direction; // text direction
    dateFnsLocale: Locale | null; // dynamically loaded date-fns locale
    toggleDirection: (() => void) | null;
    setDirection: ((dir: Direction) => void) | null;
    setLocale: ((locale: string) => void) | null;
};

export const CultureContext = createContext<CultureContextValues>({
    locale: 'en-GB',
    dir: 'ltr',
    dateFnsLocale: null,
    toggleDirection: null,
    setDirection: null,
    setLocale: null,
});
